import { FC, ReactElement } from 'react';

import WarningIcon from '@/assets/svg/ui-elements/alert-triangle-outline-orange.svg';
import VerifiedIcon from '@/assets/svg/ui-elements/check-verified.svg';
import InfoIcon from '@/assets/svg/ui-elements/info-circle-outline-blue.svg';
import DetectedIcon from '@/assets/svg/ui-elements/shield-check.svg';
import { Alert, type AlertVariant } from '@/design-system';

import { registryBannerCopy } from '../common';
import { RegistryCheckStatus } from '../use-registry-check';

interface RegistryCheckBannerProps {
  status: RegistryCheckStatus;
  onConnect: () => void;
}

type BannerVariant = Exclude<RegistryCheckStatus, 'checking'>;

const bannerVariants: Record<BannerVariant, AlertVariant> = {
  idle: 'info',
  detected: 'success',
  loaded: 'success',
  notFound: 'warning',
  error: 'warning',
};

const bannerIcons: Record<BannerVariant, ReactElement> = {
  idle: <InfoIcon />,
  detected: <DetectedIcon />,
  loaded: <VerifiedIcon />,
  notFound: <WarningIcon />,
  error: <WarningIcon />,
};

export const RegistryCheckBanner: FC<RegistryCheckBannerProps> = ({ status, onConnect }) => {
  const variant: BannerVariant = status === 'checking' ? 'idle' : status;
  const copy = registryBannerCopy[variant];

  return (
    <Alert
      size="md"
      variant={bannerVariants[variant]}
      icon={bannerIcons[variant]}
      title={copy.title}
      description={copy.description}
      action={
        variant === 'detected'
          ? { label: registryBannerCopy.detected.action, onClick: onConnect }
          : undefined
      }
    />
  );
};
